import { getField, updateField } from 'vuex-map-fields';
import listing from '../../api/listing';
import events from '../../api/events';
import locations from '../../api/locations';
import * as CONST from '../../utils/constants';

// initial state
const state = {
	error: '',
	loading: false,
	listing: [],
	resource: '', // api url for specific page listing
	specification: {},
	pagination: {
		pageIndex: 0,
		pageSize: 0,
		rowEnd: 0,
		rowStart: 0,
		total: 0,
		totalPages: 0,
	},
	initState: {},
	code: '',
	zip: '',
	rad: '',
	vEvent: false,
	vLocation: false
};

// getters
const getters = {
	getField,
};

// actions
const actions = {
	updateError({ commit, rootState }, error) {
		commit('updateError', error);
	},
	updateLoading({ commit, rootState }, loading) {
		commit('updateLoading', loading);
	},
	setEventFilter({ state, commit, rootState }) {
		// call the api with update specification object
		if (state.specification.Zipcode !== null && state.specification.Zipcode !== undefined && state.specification.Zipcode !== '') {
			//state.zip = state.specification.Zipcode;
			//state.rad = state.specification.Radius;
			commit('setZip', state.specification.Zipcode);
			commit('setRad', state.specification.Radius);
			if (state.specification.Categories === 'virtual-event') {
				//state.vEvent = true;
				commit('setVEvent', true);
			}
			events.setZipCodeFilter(data => {
				commit('setListing', data);
			}, state.specification);
		}
		else if (state.vEvent === true) {
			//state.vEvent = false;
			commit('setVEvent', false);
			//state.specification.Zipcode = state.zip;
			//state.specification.Radius = state.rad;
			commit('setSpecificationZip', state.zip);
			commit('setSpecificationRadius', state.rad);
			events.setZipCodeFilter(data => {
				commit('setListing', data);
			}, state.specification);
		}
		else {
			events.setFilter(data => {
				commit('setListing', data);
			}, state.specification);
		}
	},
	setLocationFilter({ commit, rootState }) {
		// call the api with update specification object
		if (state.specification.Zipcode !== null && state.specification.Zipcode !== undefined && state.specification.Zipcode !== '') {
			state.zip = state.specification.Zipcode;
			state.rad = state.specification.Radius;
			if (state.specification.Categories === 'virtual-location') {
				state.vLocation = true;
			}
			locations.setZipCodeFilter(data => {
				commit('setListing', data);
			}, state.specification);
		}
		else if (state.vLocation === true) {
			state.vLocation = false;
			state.specification.Zipcode = state.zip;
			state.specification.Radius = state.rad;
			locations.setZipCodeFilter(data => {
				commit('setListing', data);
			}, state.specification);
		}
		else {
			locations.setFilter(data => {
				commit('setListing', data);
			}, state.specification);
		}
	},
	setFilter({ commit, rootState }) {
		//console.log('filter', rootState);
		// call the api with update specification object
		listing.setFilter(data => {
			commit('setListing', data);
		}, { specification: state.specification, resource: state.resource });
	},
	setSearchFilter({ commit, rootState }) {
		// call the api with update specification object
		search.setFilter(data => {
			commit('setListing', data);
		}, { specification: state.specification, resource: state.resource });
	},
};

// mutations
const mutations = {
	updateField,
	updateError(state, error) {
		state.error = error;
	},
	updateLoading(state, loading) {
		state.loading = loading;
	},
	setZip(state, zip) {
		state.zip = zip;
	},
	setRad(state, rad) {
		state.rad = rad;
	},
	setVEvent(state, value) {
		state.vEvent = value;
	},
	setSpecificationZip(state, zip) {
		state.specification.Zipcode = zip;
	},
	setSpecificationRadius(state, radius) {
		state.specification.Radius = radius;
	},
	setInitData(state, result) {
		//console.log('initdata', state, result);
		// on load of app, load in data
		state.initState = result;

		state.listing = result.Items;
		state.specification = result.Specification;

		state.pagination.pageIndex = result.PageIndex + 1;
		state.pagination.pageSize = result.PageSize;
		state.pagination.rowEnd = result.RowEnd;
		state.pagination.rowStart = result.RowStart;
		state.pagination.total = result.Total;
		state.pagination.totalPages = result.TotalPages;

		state.isCategoryTopic = result && result.Specification && result.Specification.IsCategoryTopic === true;
	},
	setResource(state, resource) {
		state.resource = resource;
	},
	updateSpecification(state, param) {
		//console.log('specification', state, param);
		// on each input change, update the specification object
		state.specification[param.key] = param.value;

		let queryParams = [];

		// when executing any filter outside of paging, set paging to 0
		if (param.key !== 'PageIndex') {
			state.specification.PageIndex = 0;
			state.pagination.pageIndex = 1;
		}
		else {
			state.pagination.pageIndex = param.value + 1;
		}

		if (param.key === 'PublishBefore') {
			if (param.value && state.specification.PublishAfter) {
				const before = new Date(param.value);
				const after = new Date(state.specification.PublishAfter);
				if (after >= before) {
					state.specification.PublishAfter = null;
				}
			}
			queryParams.push(`PublishBefore=${state.specification.PublishBefore}`);
		} else if (param.key === 'PublishAfter') {
			if (param.value && state.specification.PublishBefore) {
				const after = new Date(param.value);
				const before = new Date(state.specification.PublishBefore);
				if (after >= before) {
					state.specification.PublishBefore = null;
				}
			}
			queryParams.push(`PublishAfter=${state.specification.PublishAfter}`);
		}

		if (state.specification.Topic) {
			queryParams.push(`topic=${state.specification.Topic}`);
			param.value = state.specification.Topic;
		}

		//if (state.specification.Topic && !(state.resource && state.resource.toLowerCase().includes('advocacy'))) {
			//queryParams.push(`topic=${state.specification.Topic}`);
			//param.value = state.specification.Topic;
		//}

		if (state.specification.StoryTopic) {
			queryParams.push(`topic=${state.specification.StoryTopic}`);
			param.value = state.specification.StoryTopic;
		}

		if (state.specification.issue_topic) {
			queryParams.push(`topic=${state.specification.issue_topic}`);
			param.value = state.specification.issue_topic;
		}

		if (state.specification.StartsWith) {
			queryParams.push(`StartsWith=${state.specification.StartsWith}`);
			param.value = state.specification.StartsWith;
		}

		if (state.specification.AssetType) {
			queryParams.push(`assetType=${state.specification.AssetType}`);
			param.value = state.specification.AssetType;
		}

		if (state.specification.Type) {
			queryParams.push(`type=${state.specification.Type}`);
			param.value = state.specification.Type;
		}

		if (state.specification.RelatedState) {
			queryParams.push(`relatedState=${state.specification.RelatedState}`);
			param.value = state.specification.RelatedState;
		}

		if (state.specification.SearchTerm) {
			queryParams.push(`searchTerm=${state.specification.SearchTerm}`);
			param.value = state.specification.SearchTerm;
		}

		if (state.specification.Disease) {
			queryParams.push(`disease=${state.specification.Disease}`);
			param.value = state.specification.Disease;
		}

		if (state.specification.StoryDisease) {
			queryParams.push(`disease=${state.specification.StoryDisease}`);
			param.value = state.specification.StoryDisease;
		}

		if (state.specification.disease_category) {
			queryParams.push(`disease=${state.specification.disease_category}`);
			param.value = state.specification.disease_category;
		}

		if (state.specification.TrialLocation) {
			queryParams.push(`location=${state.specification.TrialLocation}`);
			param.value = state.specification.TrialLocation;
		}

		if (state.specification.AdvocacyAlertRelatedState) {
			queryParams.push(`state=${state.specification.AdvocacyAlertRelatedState}`);
			param.value = state.specification.AdvocacyAlertRelatedState;
		}

		if (state.specification.ResourceType) {
			queryParams.push(`type=${state.specification.ResourceType}`);
			param.value = state.specification.ResourceType;
		}

		if (state.specification.ResourceTopic) {
			queryParams.push(`topic=${state.specification.ResourceTopic}`);
			param.value = state.specification.ResourceTopic;
		}

		if (state.specification.ResourceDisease) {
			queryParams.push(`disease=${state.specification.ResourceDisease}`);
			param.value = state.specification.ResourceDisease;
		}

		if (state.specification.ResourceAudience) {
			queryParams.push(`audience=${state.specification.ResourceAudience}`);
			param.value = state.specification.ResourceAudience;
		}

		if (state.specification.State) {
			queryParams.push(`state=${state.specification.State}`);
			param.value = state.specification.State;
		}

		if (state.specification.Department) {
			queryParams.push(`department=${state.specification.Department}`);
			param.value = state.specification.Department;
		}

		if (state.specification.PositionType) {
			queryParams.push(`positionType=${state.specification.PositionType}`);
			param.value = state.specification.PositionType;
		}

		if (state.specification.OfficeLocation) {
			queryParams.push(`officeLocation=${state.specification.OfficeLocation}`);
			param.value = state.specification.OfficeLocation;
		}

		if (state.specification.ResearchTopic) {
			queryParams.push(`topic=${state.specification.ResearchTopic}`);
			param.value = state.specification.ResearchTopic;
		}

		if (state.specification.ResearchDisease) {
			queryParams.push(`disease=${state.specification.ResearchDisease}`);
			param.value = state.specification.ResearchDisease;
		}

		if (state.specification.ResearchGrant) {
			queryParams.push(`grant=${state.specification.ResearchGrant}`);
			param.value = state.specification.ResearchGrant;
		}

		if (param.key === 'StateCode') {
			state.code = param.value;
			state.specification.Radius = null;
			state.specification.Zipcode = null;
			queryParams.push(`state=${state.specification.StateCode}`);
		} else if ((param.key === 'Zipcode' && param.value !== '') || (param.key === 'Radius' && state.specification.Zipcode !== '')) {
			state.specification.StateCode = null;
			if (state.specification.Zipcode) {
				queryParams.push(`zipcode=${state.specification.Zipcode}`);
				state.code = param.value;
			} else {
				state.code = param.value;
				queryParams.push(`radius=${state.specification.Radius}`);
			}
		}

		if (state.specification.Categories) {
			if (state.isCategoryTopic) {
				queryParams.push(`topic=${state.specification.Categories}`);
				param.value = state.specification.Categories;
			} else {
				queryParams.push(`category=${state.specification.Categories}`);
				param.value = state.specification.Categories;
			}
		}

		if (state.specification.PageIndex > 0) {
			queryParams.push(`page=${state.pagination.pageIndex}`);
		}

		// for the SwiftType search page, update the page hash, otherwise pushstate
		if (state.specification.Stq) {
			window.location.hash = `#stq=${state.specification.Stq}&stp=${state.pagination.pageIndex}`;
		} else {
			let pageUrl;
			pageUrl = queryParams.length ? `?${queryParams.join('&')}` : '';
			window.history.pushState('', '', window.location.pathname + pageUrl);
		}
	},
	resetSpecification(state) {
		// reset listing and filters back to their initial on load state
		state.listing = state.initState.Items;
		state.specification = state.initState.Specification;

		state.pagination.pageIndex = state.initState.PageIndex + 1;
		state.pagination.pageSize = state.initState.PageSize;
		state.pagination.rowEnd = state.initState.RowEnd;
		state.pagination.rowStart = state.initState.RowStart;
		state.pagination.total = state.initState.Total;
		state.pagination.totalPages = state.initState.TotalPages;
	},
	setListing(state, data) {
		// update listing and pagination after api call
		//console.log('listing', state, data);
		state.listing = data.Items;
		state.specification = data.Specification;

		state.pagination.pageIndex = data.PageIndex + 1;
		state.pagination.pageSize = data.PageSize;
		state.pagination.rowEnd = data.RowEnd;
		state.pagination.rowStart = data.RowStart;
		state.pagination.total = data.Total;
		state.pagination.totalPages = data.TotalPages;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};